import React, { useEffect, useRef } from 'react';
import { getClinicNumbers } from '../utils/clinicNumbers';

const AboutUs = () => {
  const refs = useRef([]);
  const { years, attendancesText, attendancesCompact } = getClinicNumbers();

  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && e.target.classList.add('in')),
      { threshold: 0.15 }
    );
    refs.current.forEach(r => r && obs.observe(r));
    return () => obs.disconnect();
  }, []);

  const r = i => el => { refs.current[i] = el; };

  return (
    <>
      <div className="divider" id="sobre">
        <span><span className="dot"></span> 01 / Sobre</span>
        <span>Atendimento humanizado</span>
      </div>

      <section className="sobre">
        <div className="sobre-left">
          <div ref={r(0)} className="reveal">
            <div className="num">Índice — Sobre a clínica</div>
            <h2 className="display">
              {years} anos <em>cuidando</em> de quem sorri na zona oeste
            </h2>
          </div>
        </div>

        <div className="sobre-right">
          <p ref={r(1)} className="reveal">
            <span className="drop">D</span>esde janeiro de 2006, a Bangu Odonto Clínica acompanha gerações de
            pacientes da zona oeste do Rio. O que começou como um consultório em Bangu, se
            tornou referência em odontologia acessível, precisa e, acima de tudo, humana.
          </p>
          <p ref={r(2)} className="reveal">
            Mais de {attendancesText} atendimentos ao longo de {years} anos de existência. Técnicas modernas
            — aparelhos invisíveis, lentes de contato, implantes, próteses e clareamento —
            convivem com o que nunca sai de moda: cuidado honesto, tempo para ouvir e
            atendimento sem dor.
          </p>
          <p ref={r(3)} className="reveal">
            Nossa missão é simples: que cada paciente saia daqui se sentindo melhor do que entrou.
          </p>

          <div ref={r(4)} className="sobre-stats reveal">
            <div className="stat">
              <div className="value">{years}<em>+</em></div>
              <div className="k">Anos de trajetória na região</div>
            </div>
            <div className="stat">
              <div className="value"><em>{attendancesCompact}</em>+</div>
              <div className="k">Atendimentos com confiança</div>
            </div>
            <div className="stat">
              <div className="value">4,9<em>★</em></div>
              <div className="k">Avaliação média no Google</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
